/*
 *
 * @desc: API Config
 * @author: haifn
 * @time: 2019-06-03 14:42
 *
 */

const BASE_URL_PRODUCTION = 'https://service.insta360.com';
const BASE_URL_TEST = 'https://service-test.insta360.com';
const BASE_URL_STORE_SIT = 'https://store-service-sit.insta360.com';
const BASE_URL_SIT = 'https://service-sit.insta360.com';

const DATA_COLLECT_PRODUCTION = 'https://api-data-collection.insta360.cn/data_collection';
const DATA_COLLECT_TEST = 'https://api-data-collection-test.insta360.cn/data_collection';

let BASE_URL = BASE_URL_PRODUCTION;
let BASE_URL_INFR_BASE_SERVICE = BASE_URL_PRODUCTION;
let BASE_URL_USER = BASE_URL_PRODUCTION;
let BASE_URL_WWW = 'https://service-test.insta360.com';
export let DataCollectBaseUrl = DATA_COLLECT_PRODUCTION;

if (typeof window !== 'undefined') {
  window.isProd =
    ['store.insta360.com', 'store-scan.insta360.com'].includes(window.location.host) ||
    window?.__NEXT_DATA__?.props?.pageData?.appInject?.isProd;
  window.isSit = ['store-sit.insta360.com'].includes(window.location.host);
  BASE_URL = window.isProd ? BASE_URL_PRODUCTION : window.isSit ? BASE_URL_STORE_SIT : BASE_URL_TEST;
  BASE_URL_USER = window.isProd ? BASE_URL_PRODUCTION : window.isSit ? BASE_URL_SIT : BASE_URL_TEST;
  DataCollectBaseUrl = window.isProd ? DATA_COLLECT_PRODUCTION : DATA_COLLECT_TEST;
  BASE_URL_INFR_BASE_SERVICE = window.isProd ? BASE_URL_PRODUCTION : BASE_URL_TEST;
  BASE_URL_WWW = window.isProd ? 'https://service.insta360.com' : BASE_URL_WWW;
}

export const BASE_STORE_URL = BASE_URL + '/store-service/store';

export const BASE_WWW_URL = BASE_URL_WWW + '/www-service';

export const SERVER = {
  API_SERVER_BASE: BASE_STORE_URL,
  API_SERVER_USER: BASE_STORE_URL + '/user',
  API_SERVER_META: BASE_STORE_URL + '/meta',
  API_SERVER_PRODUCT: BASE_STORE_URL + '/product',
  API_SERVER_RESELLER: BASE_STORE_URL + '/reseller',
  API_SERVER_TRADE: BASE_STORE_URL + '/trade',
  API_SERVER_ORDER: BASE_STORE_URL + '/order',
  API_SERVER_TRADEUP_Fresh: BASE_STORE_URL + '/tradeup/fresh',
  API_SERVER_TRADEUP: BASE_STORE_URL + '/tradeup',
  API_SERVER_RMA: BASE_STORE_URL + '/rma',
  API_SERVER_PAYMENT: BASE_STORE_URL + '/payment',
  API_SERVER_CLOUD: BASE_STORE_URL + '/cloud',

  API_SERVER_INFR_BASE: BASE_URL_INFR_BASE_SERVICE + '/infr-base-service/base',
  API_SERVER_ACCOUNT: BASE_URL_USER + '/infr-user-service/account/v1',
  API_SERVER_ACCOUNT_V2: BASE_URL_USER + '/infr-user-service/account/v2',
  API_SERVER_CREDIT: BASE_URL + '/infr-point-service/credit',
  API_SERVER_DATA_COLLECTION: BASE_URL + '/be-data-collection/data_collection/v1',
  API_SERVER_DEVICE: BASE_URL + '/app-service/device/v1',
  API_SERVER_SUPPORT_V1: BASE_URL + '/www-service/support/v1',
  API_SERVER_STABLE_DIFFUSION: BASE_URL + '/stable-diffusion-service',

  PAGE_SERVER_PAYMENT: BASE_STORE_URL + '/trade/page/payment',
};
